import React, { Component} from 'react'
import { connect} from 'react-redux'
import { bindActionCreators} from 'redux'
import { Card} from 'antd'
import CScroll from '@/components/CScroll'
import { setReload, setWindowInfo} from "@/redux/common/action";
import './index.scss'

class MainContent extends Component{

  constructor(props) {
    super(props);
    this.reload = this.reload.bind(this);
  }


  // static getDerivedStateFromProps(){
  //
  // }

  reload(){
    this.props.setReload(true);
  }
  componentWillMount(){

  }

  componentDidMount(){
  }

  componentDidUpdate(){

  }

  render(){
    return (
      <div className='main-content' id='mainContent'>
        <CScroll>
          <div className='main-content-scroll'>
            <div className='main-content-body'>
              <div>
                {this.props.children}
              </div>
            </div>
          </div>
        </CScroll>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    breadcrumbData: state.breadcrumbData,
    windowInfo: state.windowInfo,
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch),
    setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
